/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMiscBill.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/misc-bill";

export class AutogenModelMiscBill<RowType extends ModelRow> extends Endpoint<RowType, RowMiscBillFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMiscBill extends ModelRow<RowMiscBillFields> {
	constructor(values?: Partial<RowMiscBillFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMiscBillFields {
	ar_cycle_code_id: string;
	bill_date: Date;
	bill_type: string;
	billing_user_id: string;
	company_id: string;
	currency_type: string;
	"customer.name": string;
	customer_id: string;
	end_date: Date;
	id: string;
	invoice_no: number;
	invoice_no_string: string;
	last_bill_date: Date;
	order_id: string;
	printed: string;
	purchase_order_no: string;
	ready_to_process: string;
	recur_billed_amt: number;
	recur_billed_amt_c: string;
	recur_billed_amt_d: Date;
	recur_billed_amt_n: number;
	recur_billed_amt_r: number;
	recur_billed_no: number;
	reference_number: string;
	remark: string;
	start_date: Date;
	total_charges: number;
	total_charges_c: string;
	total_charges_d: Date;
	total_charges_n: number;
	total_charges_r: number;
	totalcharge_and_excisetax: number;
	totalcharge_and_excisetax_c: string;
	totalcharge_and_excisetax_d: Date;
	totalcharge_and_excisetax_n: number;
	totalcharge_and_excisetax_r: number;
	tw_seg_code: string;
}

